/**
 * Anmeldung, Profil, Passwortwechsel, Abmeldung. Die vier Routen sind aus Phase 1 BEKANNT UND
 * STABIL (`backend/src/http/routes/auth.ts`) - hier steht also keine Annahme, sondern der gebaute
 * Vertrag.
 *
 * `anmelden` setzt das Sitzungstoken selbst in `basis.ts`; `abmelden` verwirft es. Alles Weitere -
 * Persistenz in `localStorage`, Anmeldemaske, Rechteanzeige - gehoert zu den Tasks 7 und 14 und
 * steht bewusst nicht hier.
 */
import { anfrage, setzeSitzungsToken } from "./basis.ts";
import type { Nutzer } from "../state/reduzierer.ts";

export interface AnmeldeErgebnis {
  token: string;
  user: Nutzer;
  permissions: string[];
  /** KI-Zugang eingeschaltet (`MCP_AKTIV`)? Fehlt bei einem aelteren Backend; siehe `ProfilErgebnis`. */
  kiZugangAktiv?: boolean;
}

export interface ProfilErgebnis {
  user: Nutzer;
  permissions: string[];
  /**
   * Ist der KI-Zugang im Bestellhub eingeschaltet (`MCP_AKTIV`)? Nur `true` zeigt im Marken-Menue den Eintrag
   * "Meine KI-Zugänge" (Spec: Schalter aus = Rollout ohne Wirkung); `false` und ein fehlendes Feld (aelteres Backend)
   * zeigen ihn nicht.
   */
  kiZugangAktiv?: boolean;
}

export async function anmelden(username: string, password: string): Promise<AnmeldeErgebnis> {
  const ergebnis = await anfrage<AnmeldeErgebnis>("/api/auth/login", {
    methode: "POST",
    koerper: { username, password },
  });
  setzeSitzungsToken(ergebnis.token);
  return ergebnis;
}

/** Die eigene Sitzung pruefen und Nutzer + Rechte holen (Bestand: `bootstrapSession()`). */
export function eigenesProfil(signal?: AbortSignal): Promise<ProfilErgebnis> {
  return anfrage<ProfilErgebnis>("/api/auth/me", { signal });
}

/**
 * Passwortwechsel. Ein falsches aktuelles Passwort beantwortet das Backend bewusst mit 400, NICHT
 * mit 401 - sonst wuerfe ein Tippfehler den Nutzer ueber die 401-Behandlung in `basis.ts` aus der
 * Anwendung (siehe Kommentar in `backend/src/http/routes/auth.ts`).
 */
export async function passwortAendern(
  currentPassword: string,
  newPassword: string,
): Promise<void> {
  await anfrage<{ ok: true }>("/api/auth/password", {
    methode: "POST",
    koerper: { currentPassword, newPassword },
  });
}

export async function abmelden(): Promise<void> {
  try {
    await anfrage<{ ok: true }>("/api/auth/logout", { methode: "POST" });
  } finally {
    // Auch wenn der Aufruf scheitert (Netz weg, Sitzung serverseitig schon fort): lokal ist die
    // Sitzung in jedem Fall beendet. Ein Fehler darf den Nutzer nicht angemeldet zuruecklassen.
    setzeSitzungsToken(null);
  }
}
